import { React, useRef, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import ButtonLink from "./ButtonLink";
import {SectionHeader} from "./Header";
import { Link } from "react-router-dom";

function ContactCTA() {

    // const containerRef = useRef(null);
    // const [isView, setIsView] = useState(false);
  
    const { ref:myRef, inView: myElementIsVisible } = useInView({threshold: 0.25,triggerOnce : true, rootMargin: "100px 0px", root: null});
  
  
    
  
      return (<>
  <section className="CTA__wrapper"ref={myRef}>
  <div className={` ${myElementIsVisible?'animated':'animation'}`}>
  <SectionHeader textColour="#f55a59" smallText="Think I can help?"
              largeText="GET IN TOUCH"></SectionHeader>


  <div className="about"    >
     <p>Think we might be friends for your next adventure? <br/>
Take a minute, I’d love to hear about your project.</p>   
      <div className="btn__wrap">
     
     <Link to="/contact">
        <ButtonLink page="/contact">CONTACT ME</ButtonLink> </Link>
      </div>
  </div>
 
  
  </div></section>
  
   </>
      );
    }

export default ContactCTA;